<ul class="tbw-fed-error-list"
  *ngIf="shouldShowErrors()">
  <li class="tbw-warning-text tbw-fed-error"
    *ngFor="let error of listOfErrors()">{{error}}</li>
</ul>
